import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__inner">
          <div className="site-footer__brand">
            <Link className="site-footer__logo" to="/">GEO_AI</Link>
            <p>© 2024 GEO_AI Systems. Geological Precision through Neural Intelligence.</p>
          </div>
          <nav className="site-footer__nav" aria-label="Footer navigation">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/contact-support">Contact Support</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
